import React from 'react';
import { Link } from 'react-router-dom';
import moment from "moment";

import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/ButtonBase';
import { connect } from "react-redux";

import TextTruncater from '../../TextTruncater';
import Currency from '../../Currency';
import CellLodgingDetails from './Details';
import TrustYou from '../../TrustYou'
import UnitRatings from '../../UnitRatings';
import SpotlioIcon from '../../Icon';
import Drawer from "../../Drawer";
import MobileMessage from "../../MobileMessage";
import MarkerPin from "../../Map/mapbox/marker-pin";

import PushHistory from '../../../utils/PushHistory';
import IntlMessage from '../../../LocaleEngine';
import { slugify } from "../../../utils/string";
import QS from '../../../utils/QueryStringRetriever';

import { getSystemSettings, getDestination, getFormData } from '../../../utils/SettingsRetriever';
import LocaleAsString from "../../../LocaleEngine/LocaleAsString";

import './index.scss';

class CellLodging extends React.Component {
    constructor(props){
        super(props);

        this.state = {
            value: 0,
            currentSupplier: 0,
            cellLodging: false
        }

        this.supplierPricing = {
            primaryPrice: {
                type: "price",
                timeSpan: "perNight"
            },
            upperPrice: {
                type: "savings",
                timeSpan: "percent"
            }
        }

        this.discountMessage = "up to";

        this.descriptionLines = 100;

        if(this.props.sectionConfiguration) {
            if (this.props.sectionConfiguration.supplierPricing) this.supplierPricing = this.props.sectionConfiguration.supplierPricing;
            if (this.props.sectionConfiguration.discountMessage) this.discountMessage = this.props.sectionConfiguration.discountMessage;
            if (this.props.sectionConfiguration.descriptionLines) this.descriptionLines = this.props.sectionConfiguration.descriptionLines;
        }
    }

    onClick = (value) => {
        this.setState({ currentSupplier: value }, () => {
            let event = new CustomEvent("updateMapCarousel", 
              { 
                "detail": 
                {
                  "selectedNumber": this.state.currentSupplier,
                  "from": "supplier"
                } 
              }
            )
            document.dispatchEvent(event);
        })
    };

    openTab = () => {
        this.props.toggleSupplier(this.props.index)
        this.setState({ value: 1 })
    }

    openPhotoTab = () => {
        if(window.innerWidth <= 991) return;
        if(this.props.goToSupplier) return;
        this.props.toggleSupplier(this.props.index)
        this.setState({ value: 2 })
    }
    
    viewRooms(){
        this.setState({ value: 0 })
        this.props.toggleSupplier(this.props.index)
    }
    
    handleChange = (event, newValue)  => {
        this.setState({ value: newValue });
    }

    addToCart = (element, productIndex) => {
        this.setState({ cellLodging: false })
        this.props.addToCart(element, productIndex)
    }

    openIfMobile = (link, number, config, supplier) => {
        this.onClick(number);
        if(window.innerWidth <= 991 && this.props.compact) {
            this.setDrawerOpen(true);
            return;
        }
        if (!this.props.goToSupplier){
            if ((window.innerWidth >= 991 && !this.props.goToSupplier) || this.props.compact){
                return;
            } else {
                if ( (this.state.currentSupplier === this.props.index) ){
                    if (this.props.make){
                        link += '/?arrivalDate=' + getFormData().lodging.arrivalDate + '&departureDate=' + getFormData().lodging.departureDate + '&adults=' + getFormData().lodging.adults + '&children=' + getFormData().lodging.children
                        if (this.props.sectionConfiguration && this.props.sectionConfiguration.childrenAgesSelector && getFormData().lodging.childrenAges){
                            link += "&childrenAges=" + getFormData().lodging.childrenAges.join(",")
                        }
                    }
                    PushHistory(link, false)
                }
            }
        }
    }

    getIndexOfProduct = (productId) => {
        let index = 0;
        this.props.element.Products_Lodging.forEach((prod, idx) => {
            if (prod.ProductId === productId){
                index = idx;
            }
        })

        return index;
    }
    
    getCurrency(displayType){
        const { element } = this.props;
        let supplierPricing = {
            timeSpan: "perNight"
        }
        if (this.props.supplierPricing && this.props.supplierPricing.timeSpan){
            supplierPricing = this.props.supplierPricing;
        }

        let currency = null;
        switch (displayType){
            case 1:
                currency = (
                    <div className="avgCurrency">
                        <Currency 
                            displayType={displayType} 
                            strikeThrough={true} 
                            /*onlyOriginal={true}*/
                            float={true} 
                            value={this.props.onlyProduct !== undefined ? element.Products_Lodging[this.getIndexOfProduct(this.props.onlyProduct)].Pricing.original[supplierPricing.timeSpan] : element.Supplier.Pricing.original[supplierPricing.timeSpan]} 
                        />
                        <div className="avg">
                            {LocaleAsString(`lodging.package.${supplierPricing.timeSpan}`)}
                        </div>
                    </div>
                )
            break;
            case 2:
                currency = (
                    <div className="avgCurrency">
                        {
                            (element.Supplier.Pricing && element.Supplier.Pricing.original && element.Supplier.Pricing.original.perStay > element.Supplier.Pricing.price.perStay) && (
                                <Currency 
                                    displayType={displayType} 
                                    strikeThrough={true} 
                                    /*onlyOriginal={true}*/
                                    float={true} 
                                    value={this.props.onlyProduct !== undefined ? element.Products_Lodging[this.getIndexOfProduct(this.props.onlyProduct)].Pricing.original[supplierPricing.timeSpan] : element.Supplier.Pricing.original[supplierPricing.timeSpan]} 
                                />
                            )
                        }
                        <Currency 
                            /*onlyOriginal={true}*/
                            float={true} 
                            value={this.props.onlyProduct !== undefined ? element.Products_Lodging[this.getIndexOfProduct(this.props.onlyProduct)].Pricing.price[supplierPricing.timeSpan] : (element.Supplier.Pricing.price[supplierPricing.timeSpan] || element.Supplier.Pricing.original[supplierPricing.timeSpan])} 
                        />
                        <div className="avg">
                            {LocaleAsString(`lodging.package.${supplierPricing.timeSpan}`)}
                        </div>
                    </div>
                )
            break;
            case 3:
            break;
            default:
            break;
        }
        return currency;
    }

    getPricing = (pricing, position) => {
        let prices = null;
        let type = this.supplierPricing[position].type;
        if ( 
            this.props.sectionConfiguration.overWritePricingWithDisplayType && 
            this.props.element.Products_Lodging && 
            this.props.element.Products_Lodging[0] && 
            this.props.element.Products_Lodging[0].Packages && 
            this.props.element.Products_Lodging[0].Packages[0] && 
            this.props.element.Products_Lodging[0].Packages[0].DisplayType === 3)
        {
            if (position === "primaryPrice") {
                type = "original"
            }
            if (position === "upperPrice") {
                type = ""
            }
        }
        switch(type){
            case "savings":
                if (this.supplierPricing.upperPrice.timeSpan === "percent" && pricing.savings.percent > 0){
                    prices = (
                        <div className="discount">
                            {this.discountMessage} -{pricing.savings.percent}%
                        </div>
                    )
                }
            break;
            case "original":
            case "price": 
                prices = (
                    <div className="finalPrice">
                        <div className="finalPriceDetails">
                            {this.props.element.Products_Lodging.length > 1 && <span>{LocaleAsString("lodging.product.from")}</span>}
                            <Currency float={this.props.sectionConfiguration && this.props.sectionConfiguration.avgNightFloat} value={pricing[type][this.supplierPricing.primaryPrice.timeSpan]} />
                        </div>
                        <span className="avg">{LocaleAsString(`lodging.package.${this.supplierPricing.primaryPrice.timeSpan}`)}</span>
                    </div>
                )
            break;
            default: prices = null;
        }

        return prices;
    }

    setDrawerOpen = (cellLodging) => {
        this.setState({ 
            value: cellLodging ? 0 : this.state.value,
            cellLodging
        })
    }

    getDestinationName = () => {
        let destinationName = '';
        if (getDestination()) {
            if (getDestination().length > 1) {
                destinationName = "Multiple destinations";
                return destinationName;
            }
            getSystemSettings().multiDestination && getSystemSettings().multiDestination.list.forEach(destination => {
                if ( getDestination().find( dest => parseInt(dest) === parseInt(destination.id) ) ) {
                    destinationName = destination.name;
                }
            })
        }
        return destinationName;
    }

    getRatings = (rooms) => {
        if (rooms && rooms.length > 0){
            let minRating = undefined;
            let maxRating = undefined;

            rooms.forEach(room => {
                if (room.UnitRating !== null){
                    if (room.UnitRating < minRating || minRating === undefined){
                        minRating = room.UnitRating;
                    }
                    if (room.UnitRating > maxRating || maxRating === undefined){
                        maxRating = room.UnitRating;
                    }
                }
            })

            if(minRating !== undefined && maxRating !== undefined && minRating !== 0 && maxRating !== 0 && minRating !== null && maxRating !== null){
                if (minRating === maxRating){
                    return <UnitRatings ratings={minRating} />
                } else {
                    return (
                        <div className="ratings">
                            <UnitRatings ratings={minRating} />
                            <span>-</span>
                            <UnitRatings ratings={maxRating} />
                        </div>
                    )
                }
            }
            
        }
        return null;
    }

    getOffer30Days = (supplierId) => {
        const { sectionConfiguration } = this.props;
       
        let today = moment.utc().startOf("day");
        let searchDate = moment.utc(this.props.form.lodging.arrivalDate).startOf("day");

        if (sectionConfiguration && sectionConfiguration.offer30days && sectionConfiguration.offer30days.enabled){
            if (today.add(sectionConfiguration.offer30days.daysExcluded, 'days').isSameOrBefore(searchDate) && !sectionConfiguration.offer30days.suppliersExcluded.find(sup => sup === supplierId)){
                let currencyList = getSystemSettings().app.currency.list;
                let currency = currencyList.find(curr => curr.base === sectionConfiguration.offer30days.currency)
                let symbol = "$"
                if (currency) symbol = currency.symbol
                return (
                    <p onMouseOver={() => this.setState({ offerToolTip: true })} onMouseLeave={() => this.setState({ offerToolTip: false })} className="offer30days">
                        {
                            sectionConfiguration.offer30days.text
                            .replace(
                                "[PRICE]",
                                `${symbol + sectionConfiguration.offer30days.price}`
                            )
                        }
                        {
                            sectionConfiguration.offer30days.popover && this.state.offerToolTip &&
                            <div className="offerTooltip">
                                <div className="offerTooltipTitle">
                                    {sectionConfiguration.offer30days.popover.title}
                                </div>
                                <div className="offerTooltipMessage">
                                    {sectionConfiguration.offer30days.popover.message}
                                </div>
                            </div>
                        }
                    </p>
                )
            }
        }

        return null;
    }

    getItemClassName = () => {
        if (this.props.showUnspanned){
            return ""
        }
        if (this.props.open !== null){
            if (this.props.open === this.props.index){
                return "opened"
            }
            return "closed"
        }
        if (this.props.onlyProduct !== undefined){
            return "opened"
        }
        return "";
    }
 
    checkForOpacity = () => {
        const config = getSystemSettings(false).theme;

        let opacity = 0;
        if(config && config.results && config.results.resultOpacity) {
            opacity = config.results.resultOpacity;
        }

        if(opacity && typeof opacity === "number" && this.getItemClassName() === "closed" && this.props.mode !== "map") {
            return { opacity: opacity };
        }

        return null;
    }

    render (){
        const { getPricing, props } = this;
        const { index, element, goToSupplier = false, sectionConfiguration } = props;
        let linkToSupplierPage = '/supplier/' + slugify(element.Supplier.SupplierName) + '/' + element.Supplier.SupplierId;

        if(element.Supplier && element.Supplier.ProductSuperCategoryId && element.Supplier.ProductSuperCategoryId > 1) {
            linkToSupplierPage = linkToSupplierPage + '?productSuperCategory=' + element.Supplier.ProductSuperCategoryId;
        }

        if (element === undefined){
            return null;
        } else {
            let featuredCondition = element.Supplier && element.Supplier.SupplierId === QS().featured;
            let viewRoomsKey = "lodging.product.view_rooms"
            if (sectionConfiguration && sectionConfiguration.label_customization){
                if (sectionConfiguration.label_customization[viewRoomsKey]) viewRoomsKey = sectionConfiguration.label_customization[viewRoomsKey];
            }
            let className=`item lodging ${this.getItemClassName()} ${featuredCondition ? " featured" : ""}
            `
            const lodgingCell = (
                <Grid onClick={()=>this.openIfMobile(linkToSupplierPage, index, sectionConfiguration, element)} key={index + 'cell'} item xs={12} style={this.checkForOpacity()} className={className} data-id={element.Supplier.SupplierId}>
                    {featuredCondition && <span className="featuredText">Featured Property</span>}
                    <div className="multimedia" onClick={() => this.openPhotoTab()}>
                        {sectionConfiguration && sectionConfiguration.numbersOnImages && sectionConfiguration.numbersOnImages.enabled && element.Supplier.Lat && getSystemSettings().app.enableMap !== false 
                            ? <div style={element.Neighborhood ? { backgroundColor: element.Neighborhood.color, borderTopColor: element.Neighborhood.color } : null} className="floatingSupplierNumber">
                                {index + 1}
                            </div>
                            : null
                        }
                        <img src={element.Image.Delivery + element.Image.FileName} alt={element.Supplier.SupplierName} />
                        {element.Trustyou ? <TrustYou element={element.Trustyou.api_response} /> : null}
                    </div>
                    <div className="content">
                        <div className="mainInfo">
                            <div className="titleWrap">
                                <Typography variant="h6" className="title">{element.Supplier.SupplierName}</Typography> 
                                {
                                    element.Supplier.special && sectionConfiguration && sectionConfiguration.markAsSpecial &&
                                    <div className={"special"}>
                                        {LocaleAsString(sectionConfiguration.markAsSpecial)}
                                    </div>
                                }
                                {this.getRatings(element.Products_Lodging)}
                            </div>
                            {goToSupplier ?
                            <div className="address">
                                <span>{element.Supplier.Address}</span>
                                <span>{element.Supplier.City+", "+element.Supplier.Region+", "+element.Supplier.Country}</span>
                            </div>
                            :
                            <div className="locationWrap">
                                {
                                    sectionConfiguration && sectionConfiguration.numbersOnPins && sectionConfiguration.numbersOnPins.enabled && element.Supplier.Lat && getSystemSettings().app.enableMap !== false
                                    ?
                                    <MarkerPin 
                                        mode={"supplierNumber"}
                                        color={element.Neighborhood ? element.Neighborhood.color : undefined}
                                        number={index} 
                                        size={16} 
                                    />
                                    :
                                    <SpotlioIcon 
                                        color={element.Neighborhood ? element.Neighborhood.color : undefined} 
                                        size={16} 
                                        icon={"sp3-location-pin"} 
                                    />
                                }
                                {element.Neighborhood ? <span style={{color: element.Neighborhood.color}}>{element.Neighborhood.name}</span> : <span>{element.Supplier.City}</span>}
                            </div>
                            }

                            <div className="descriptionWrap">
                                <Typography variant="body2" component="div" className="description">
                                    <TextTruncater Function={ sectionConfiguration && sectionConfiguration.showDescriptionInline ? null : this.openTab.bind(this) } text={element.Supplier.SupplierDescription} sufix={'...'} limit={this.descriptionLines} mode={'word'} />
                                </Typography>
                                
                            </div>
                        </div>
                        <div className="pricing">
                            {
                                this.props.make ? element.Products_Lodging.length === 0 
                                ? <Currency float={sectionConfiguration && sectionConfiguration.avgNightFloat} make={this.props.make} value={0} /> 
                                : this.props.displayType ? this.getCurrency(this.props.displayType) 
                                :
                                <React.Fragment>
                                    {getPricing(element.Supplier.Pricing, "upperPrice")}
                                    {getPricing(element.Supplier.Pricing, "primaryPrice")}
                                    
                                </React.Fragment>
                                : this.props.loadingSearch ? <Currency loadingSearch={this.props.loadingSearch} value={0} /> : null}
                                {this.getOffer30Days(element.Supplier.SupplierId)}
                            <div className="main-cta">
                                {
                                    goToSupplier ?
                                    <Link className="linkTo" to={linkToSupplierPage}>
                                        <IntlMessage id="suppliers.more_info" />
                                        <SpotlioIcon size={16} icon={"feather-chevron-right"} />
                                    </Link>
                                    :
                                    !this.props.showUnspanned ?
                                    <Button onClick={() => this.viewRooms()} className={(this.props.index === this.props.open ? "opened " : " " ) + "primary"}>
                                        <IntlMessage 
                                            tag={true} 
                                            id={viewRoomsKey}
                                            />
                                        { this.props.open === index ? <SpotlioIcon size={16} icon={'feather-chevron-up'}/> : <SpotlioIcon size={16} icon={'feather-chevron-down'}/>}
                                    </Button>
                                    : null
                                }
                            </div>
                        </div>
                    </div>
                </Grid>
            )
            
            if (this.props.mode === "map"){
                return lodgingCell
            } else {
                return (
                    <>
                        {lodgingCell}
                        {this.props.compact
                            ? window.innerWidth <= 991
                                ? 
                                <Drawer 
                                    disablePortal={true} 
                                    onEscapeKeyDown={() => this.setDrawerOpen(false)} 
                                    onBackdropClick={() => this.setDrawerOpen(false)} 
                                    variant={'temporary'} 
                                    anchor={'bottom'} 
                                    open={this.state.cellLodging} 
                                    className="mobileProductsModal"
                                    paperStyles={{
                                        backgroundColor: '#F4F4F9',
                                        padding: '0 !important',
                                        zIndex: '1100 !important'
                                    }}
                                >
                                    <MobileMessage
                                        toggleButton={()=> this.setDrawerOpen(false) }
                                        isBackButton
                                        currentStep={element.Supplier.SupplierName}
                                        pastSteps={[this.getDestinationName()]}
                                        arrivalDate={this.props.form.lodging.arrivalDate}
                                        departureDate={this.props.form.lodging.departureDate}
                                        guests={this.props.form.lodging.adults + this.props.form.lodging.children}
                                        mode={"lodging"}
                                    />
                                    <div className={"productsModalWrapper"}>
                                        <Grid key={index + 'cell'} item xs={12} className={className} data-id={element.Supplier.SupplierId}>
                                            <div className="multimedia">
                                                <img src={element.Image.Delivery + element.Image.FileName} alt={element.Supplier.SupplierName} />
                                                {element.Trustyou ? <TrustYou element={element.Trustyou.api_response} /> : null}
                                            </div>
                                            <div className="content">
                                                <div className="mainInfo">
                                                    <div className="titleWrap">
                                                        <Typography variant="h6" className="title">{element.Supplier.SupplierName}</Typography> 
                                                        { element.UnitRatings ? <UnitRatings ratings={element.UnitRatings}/> : null }
                                                    </div>
                                                    {goToSupplier ?
                                                    <div className="address">
                                                        <span>{element.Supplier.Address}</span>
                                                        <span>{element.Supplier.City+", "+element.Supplier.Region+", "+element.Supplier.Country}</span>
                                                    </div>
                                                    :
                                                    <div className="locationWrap">
                                                        <SpotlioIcon color={element.Neighborhood ? element.Neighborhood.color : undefined} size={16} icon={"sp3-location-pin"} />
                                                        {element.Neighborhood ? <span style={{color: element.Neighborhood.color}}>{element.Neighborhood.name}</span> : <span>{element.Supplier.City}</span>}
                                                    </div>
                                                    }

                                                    <div className="descriptionWrap">
                                                        <Typography variant="body2" component="div" className="description">
                                                            <TextTruncater Function={ sectionConfiguration && sectionConfiguration.showDescriptionInline ? null : this.openTab.bind(this)} text={element.Supplier.SupplierDescription} sufix={'...'} limit={100} mode={'word'} />
                                                        </Typography>
                                                        
                                                    </div>
                                                </div>
                                                <div className="pricing">
                                                    {
                                                        this.props.make ? element.Products_Lodging.length === 0 
                                                        ? <Currency float={sectionConfiguration && sectionConfiguration.avgNightFloat} make={this.props.make} value={0} /> 
                                                        : this.props.displayType ? this.getCurrency(this.props.displayType) 
                                                        :
                                                        <React.Fragment>
                                                            {getPricing(element.Supplier.Pricing, "upperPrice")}
                                                            {getPricing(element.Supplier.Pricing, "primaryPrice")}
                                                        </React.Fragment>
                                                        : this.props.loadingSearch ? <Currency loadingSearch={this.props.loadingSearch} value={0} /> : null}
                                                    <div className="main-cta">
                                                        {
                                                            goToSupplier ?
                                                            <Link className="linkTo" to={linkToSupplierPage}>
                                                                <IntlMessage id="suppliers.more_info" />
                                                                <SpotlioIcon size={16} icon={"feather-chevron-right"} />
                                                            </Link>
                                                            :
                                                            !this.props.showUnspanned ?
                                                            <Button className={(this.props.index === this.props.open ? "opened " : " " ) + "primary"}>
                                                                <IntlMessage 
                                                                    tag={true} 
                                                                    id={viewRoomsKey}
                                                                    />
                                                                { this.props.open === index ? <SpotlioIcon size={16} icon={'feather-chevron-up'}/> : <SpotlioIcon size={16} icon={'feather-chevron-down'}/>}
                                                            </Button>
                                                            : null
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                        </Grid>
                                        <CellLodgingDetails 
                                            amountOfComponents={this.props.amountOfComponents}
                                            section={this.props.section} 
                                            featuredCondition={featuredCondition}
                                            policies={element.Policies}
                                            sectionConfiguration={sectionConfiguration}
                                            currentStep={this.props.currentStep}
                                            updateStep={this.props.updateStep}
                                            displayType={this.props.displayType}
                                            onlyProduct={this.props.onlyProduct}
                                            addToCart={this.addToCart.bind(this)}
                                            compact={this.props.compact}
                                            value={this.state.value}
                                            handleChange={this.handleChange.bind(this)}
                                            index={index}
                                            element={element}
                                        />
                                    </div>
                                    <div className={"bottomFixed"} onClick={() => this.setDrawerOpen(false)} >
                                        <SpotlioIcon icon="feather-x" /> Close
                                    </div>
                                </Drawer>
                                : (this.props.index === this.props.open || this.props.onlyProduct !== undefined || this.props.showUnspanned) && <CellLodgingDetails section={this.props.section} featuredCondition={featuredCondition} policies={element.Policies} sectionConfiguration={sectionConfiguration} currentStep={this.props.currentStep} updateStep={this.props.updateStep} displayType={this.props.displayType} onlyProduct={this.props.onlyProduct} addToCart={this.addToCart.bind(this)} compact={this.props.compact} value={this.state.value} handleChange={this.handleChange.bind(this)} index={index} element={element} />
                            : (this.props.index === this.props.open || this.props.onlyProduct !== undefined || this.props.showUnspanned) && <CellLodgingDetails section={this.props.section} featuredCondition={featuredCondition} policies={element.Policies} sectionConfiguration={sectionConfiguration} currentStep={this.props.currentStep} updateStep={this.props.updateStep} displayType={this.props.displayType} onlyProduct={this.props.onlyProduct} addToCart={this.addToCart.bind(this)} compact={this.props.compact} value={this.state.value} handleChange={this.handleChange.bind(this)} index={index} element={element} />
                        }                        
                    </>
                )
            }
        }
    }
}

function mapStateToProps(state) {
    return { form: state.form.form }
  }
  
  export default connect(mapStateToProps)(CellLodging)
